import { initializeApp } from 'firebase/app';
import { getFirestore, doc, setDoc,updateDoc,query,collection,limit,onSnapshot,deleteDoc, addDoc, Timestamp, getDocs,orderBy,startAfter,where, getDoc } from 'firebase/firestore';
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
import { getAuth, GoogleAuthProvider, GithubAuthProvider, FacebookAuthProvider, updateProfile, RecaptchaVerifier, signInWithPopup, signInWithPhoneNumber, createUserWithEmailAndPassword, PhoneAuthProvider, signInWithCredential } from 'firebase/auth';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_DB_API_KEY,
  authDomain: process.env.REACT_APP_DB_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_DB_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_DB_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APPID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
};

const firebaseApp = initializeApp(firebaseConfig);


// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const firestore = getFirestore(app);
const storage = getStorage(app);

const googleProvider = new GoogleAuthProvider();
const githubProvider = new GithubAuthProvider();
const facebookProvider = new FacebookAuthProvider();

const provider = new GoogleAuthProvider();

export const signInWithGoogle = () => signInWithPopup(auth, provider);

export {
  auth,
  googleProvider,
  githubProvider,
  facebookProvider,
  RecaptchaVerifier,
  signInWithPopup,
  signInWithPhoneNumber,
  createUserWithEmailAndPassword,
  PhoneAuthProvider,
  signInWithCredential,
  updateProfile,
  firestore,
  storage,
  storageRef,
  uploadBytes,
  getDownloadURL,
  firebaseConfig,
  doc,
  deleteDoc,
  limit,
  onSnapshot,
  collection,
  query,
  addDoc,
  Timestamp,
  getDocs,orderBy,startAfter,where,
  firebaseApp,
  updateDoc,
  setDoc,
  getDoc
};